import { styled } from '@acko-tech/building-blocks.ui.common';

export const DividerWrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 20px 0;
`;

export const Line = styled.hr`
    flex: 1;
    border: none;
    border-top: 1px solid #ccc;
`;

export const Text = styled.span`
    padding: 0 10px;
    color: #888;
    font-weight: 500;
    font-size: 14px;
`;
